import { render, staticRenderFns } from "./formSanalAsuulga.vue?vue&type=template&id=467ded75&"
import script from "./formSanalAsuulga.vue?vue&type=script&lang=js&"
export * from "./formSanalAsuulga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports